module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-capsules-icon-2-7516aa213ff2ea33d2dfe0ba054be841.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-capsules-icon-2.svg
 ** module id = 1003
 ** module chunks = 1 75
 **/